import { put, call, select, takeEvery } from 'redux-saga/effects'
import { baseFetch } from '../../fetch'

import {
  actionTypes as uploadActionTypes,
  actions as uploadActions,
} from '../../stores/icons/creation'

import {
  closeIconPicker,
  closeIconCreation,
} from '../../stores/pollBuilderIconPicker'
import { setSelectedExpertOpinion } from '../../stores/pollBuilderSelectedExpertOpinion'
import { selectPositionOfNewExpertOpinion } from '../../stores/pollBuilderSelectedExpertOpinion'

import { API_ICONS_URL } from '../../urls'

import { getIconFromLegacy } from '../../legacy'

export async function uploadIcon(url, name, blob) {
  const body = new FormData()
  body.append('name', name)
  body.append('file-0', blob)
  body.append('make_thumbnail', true)
  // rezise the images to 256px keeping the aspect ratio
  body.append('new_size', 256)

  const response = await baseFetch(url, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
    },
    body,
  })

  if (!response.ok)
    throw new Error(
      `Unable to upload icon: ${response.status} - ${response.statusText}`
    )

  return await response.json()
}

function* createIcon(action) {
  const { tempId, blob, name } = action.payload
  try {
    const legacyIcon = yield call(uploadIcon, API_ICONS_URL, name, blob)
    const icon = getIconFromLegacy(legacyIcon)
    yield put(uploadActions.success(icon, tempId))
    return icon
  } catch (error) {
    yield put(uploadActions.error(error, tempId))
  }
}

export function* iconCreationSaga() {
  yield takeEvery(uploadActionTypes.ICON_UPLOAD_START, function*(action) {
    const icon = yield createIcon(action)
    if (!icon) throw new Error('failed to create icon')
    yield put(closeIconCreation())
    yield put(closeIconPicker())
    const positionOfNewExpertOpinion = yield select(
      selectPositionOfNewExpertOpinion
    )
    if (positionOfNewExpertOpinion == null) {
      throw new Error(
        'expected positionOfNewExpertOpinion to not be null when creating new expert opinion'
      )
    }
    const newExpertOpinion = {
      id: icon.id, //updated by server once saved
      name: icon.name,
      text: '',
      x: positionOfNewExpertOpinion.x,
      y: positionOfNewExpertOpinion.y,
      iconId: icon.id,
      icon,
    }
    yield put(setSelectedExpertOpinion(newExpertOpinion))
  })
}



// WEBPACK FOOTER //
// ./src/sagas/icons/creation.js